export default "__VITE_ASSET__B$MoU9GC__"